import React, { useEffect, useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { useDispatch } from 'react-redux';

// COMPONENTS
import Box from '@/main/components/shared/box';
import Button from '@/main/components/shared/button/button';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import KogCheckBoxControlled from '@/main/components/shared/checkbox/checkBoxControlled';
import KogKeyboardDatePickerContainer from '@/main/components/shared/datepicker/keyboardDatePickerContainer';
import KogAutoCompleteControlled from '@/main/components/shared/inputAutoComplete/autoCompleteControlled';
import KOGAutoCompleteCheckbox from '@/main/components/shared/inputAutoCompleteCheck';
import KogAutoCompleteControlledWithDelete from '@/main/components/shared/inputAutocompleteDelete/autoCompleteControlledWithDelete';
import KOGInputRangeNumberControlled from '@/main/components/shared/inputRangeNumber/inputRangeNumber';
import KogInputTextControlledNew from '@/main/components/shared/inputText/inputTextControlledNew';
import BasicModal from '@/main/components/shared/modal/basicModal';
import { ButtonsContainer } from '@/main/components/shared/modal/style';
import ModalDeletePredefinedSearch from '@/main/components/shared/modalPredefinedSearch/ModalDeletePredefinedSearch';
import ModalSavePredefinedSearch from '@/main/components/shared/modalPredefinedSearch/ModalSavePredefinedSearch';
import RenderTooltipMessage from '@/main/components/shared/renderTooltipMessage/renderTooltipMessage';
import { AreaButton } from '@/main/components/shared/styles';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

// REDUX/UTILS/HOOKS
import VehicleAutoCompleteComponent from '@/main/components/shared/vehicle/VehicleAutoCompleteComponent';
import useFormQueryParams from '@/main/hooks/useformQueryParams';
import { KeyValue } from '@/main/models/common';
import {
  BodyShopFilterRequest,
  ClaimSearchRequest,
  InsurerFilterRequest,
  StateFilterRequest
} from '@/main/models/request';
import { Controls } from '@/main/services/constants/constantsControl';
import { HeadQuarterBranchFilterEnum } from '@/main/services/enum/HeadQuarterBranchFilterEnum';
import { ParameterTypeEnum } from '@/main/services/enum/ParameterTypeEnum';
import { StatusRegisterEnum } from '@/main/services/enum/StatusRegisterEnum';
import { VehicleAutoCompleteTypeEnum } from '@/main/services/enum/VehicleAutoCompleteTypeEnum';
import {
  enumToKeyValue,
  getDefaultCountryOptionDrop,
  getDefaultOptionDrop,
  getTranslateByFullKey,
  getTranslateByKey,
  isEmpty,
  isNullUndefined,
  isNullUndefinedEmpty,
  isShowControlByElementId,
  removeEmptyValues
} from '@/main/services/utils';
import {
  formatDateToISOString,
  getKeysIgnoreValidationsDate,
  initalDateForm,
  onLoadDateRangePicker,
  validateFormDate
} from '@/main/services/utilsDate';
import { userIsBodyshop, userIsInsurer } from '@/main/services/utilsUser';
import {
  getBodyshops,
  resetReducerBodyshops,
  useBodyshopReducer
} from '@/main/store/bodyshop';
import { getCountriesUser, useCountryReducer } from '@/main/store/country';
import {
  getInsurers,
  resetReducerInsurers,
  useInsurerReducer
} from '@/main/store/insurer';
import { useParameterByTypeScreenReducer } from '@/main/store/parameterByTypeScreen';
import {
  getPredefinedSearch,
  usePredefinedSearchReducer
} from '@/main/store/predefinedSearch';
import {
  getQuoteStatus,
  useQuoteStatusReducer
} from '@/main/store/quoteStatus';
import { getStatesUser, useStateReducer } from '@/main/store/state';
import {
  deleteUserPredefinedSearch,
  formSchema,
  getDetailsUserPredefinedSearch,
  getFavoriteSearch,
  saveFavoriteSearch,
  saveUserPredefinedSearch
} from '../searchClaimUtils';

import { RoutesConstants } from '@/main/routes/routesConstants';
import { SortByOldestEnum } from '@/main/services/enum/SortByOldestEnum';
import { toast } from 'react-toastify';
import * as S from './styles';
import SearchIcon from '@mui/icons-material/Search';
interface IFiltersSearchClaimProps {
  showFilters: boolean;
  setShowFilters: React.Dispatch<React.SetStateAction<boolean>>;
  onResetSearch: () => void;
  getDataSearchClaim: (filters: ClaimSearchRequest) => void;
}

function FiltersSearchClaim({
  showFilters,
  getDataSearchClaim,
  onResetSearch,
  setShowFilters
}: IFiltersSearchClaimProps) {
  //#region Hooks
  const dispatch = useDispatch();
  const parameterRangeDays = useParameterByTypeScreenReducer(
    ParameterTypeEnum.SearchClaimsInteval
  );
  const maxSearchRangeDaysClaimSearchScreen = useParameterByTypeScreenReducer(
    ParameterTypeEnum.MaxSearchRangeDaysClaimSearchScreen
  );
  const PARAMETER_LENTGH_FILTER_CLAIM = useParameterByTypeScreenReducer(
    ParameterTypeEnum.ClaimScreenFilterClaimLength
  );
  const showPrices = isShowControlByElementId(Controls.IdShowPrices);
  const [isIgnoreValidationsDate, setIsIgnoreValidationsDate] =
    useState<boolean>(false);

  //#endregion

  //#region Reducers
  const { countriesUser: countryReducer } = useCountryReducer();
  const { insurers: insurerReducer } = useInsurerReducer();
  const { bodyshops: bodyshopReducer } = useBodyshopReducer();
  const { quoteStatus: quoteStatusReducer } = useQuoteStatusReducer();
  const { statesUser: stateReducer } = useStateReducer();
  const { domainPredefinedSearch } = usePredefinedSearchReducer();
  //#endregion

  //#region States
  const [hasClear, setHasClear] = useState<boolean>(false);
  const [isInitialLoadScreen, setIsInitialLoadScreen] =
    useState<boolean>(false);
  const [
    openModalConfirmationFavoriteSearch,
    setOpenModalConfirmationFavoriteSearch
  ] = useState<boolean>(false);
  const [loadingFavoriteSearch, setLoadingFavoriteSearch] =
    useState<boolean>(false);
  const [reducersLoaded, setReducersLoaded] = useState(false);
  const showPredefinedSearches = isShowControlByElementId(
    Controls.IdPredefinedSearchScreenClaims
  );
  const showFavouriteSearches = isShowControlByElementId(
    Controls.IdFavouriteSearch
  );
  const showSortByOldest = isShowControlByElementId(
    Controls.IdSortByOldestSearchClaim
  );
  const [
    openModalConfirmationSavePredefinedSearch,
    setOpenModalConfirmationSavePredefinedSearch
  ] = useState<boolean>(false);
  const [loadingPredefinedSearch, setLoadingPredefinedSearch] =
    useState<boolean>(false);
  const [
    openModalConfirmationDeletePredefinedSearch,
    setOpenModalConfirmationDeletePredefinedSearch
  ] = useState<boolean>(false);
  const [predefinedSearchToDelete, setPredefinedSearchToDelete] =
    useState<KeyValue | null>(null);
  const sortByOldestOptions = enumToKeyValue(SortByOldestEnum, 'information');
  const isBodyshopUser = userIsBodyshop();
  const isInsurerUser = userIsInsurer();

  const optionDefaultCountryDrop = getDefaultCountryOptionDrop(
    countryReducer.data
  );
  const optionDefaultBodyshopDrop = getDefaultOptionDrop(bodyshopReducer.data);
  const optionDefaultInsurerDrop = isInsurerUser
    ? getDefaultOptionDrop(insurerReducer.data)
    : null;
  const INITIAL_FORM_STATE = {
    claimNumber: '',
    startDate: null as Date | null,
    finalDate: null as Date | null,
    initialTotalLoss: '',
    finalTotalLoss: '',
    insurer: null as KeyValue | null,
    bodyshopBranch: [] as KeyValue[],
    subModel: '' as string,
    vehicleManufacturer: '' as string,
    vehicleModel: '' as string,
    vehicle: '' as string,
    status: [] as KeyValue[],
    state: [] as KeyValue[],
    delayedClaim: false,
    delayedParts: false,
    unreadComments: false,
    havingItemCanceledBySupplier: false,
    predefinedSearch: null as KeyValue | null,
    sortByOldest: null as KeyValue | null
  };
  type ISearchClaimForm = typeof INITIAL_FORM_STATE;

  const methods = useFormQueryParams<ISearchClaimForm>({
    mode: 'onChange',
    defaultValues: INITIAL_FORM_STATE,
    mapDefaultValues: {
      bodyshopBranch: bodyshopReducer,
      insurer: insurerReducer,
      status: quoteStatusReducer,
      state: stateReducer,
      predefinedSearch: domainPredefinedSearch
    },
    onSubmit: onSubmit
  });
  const {
    control,
    setValue,
    getValues,
    clearErrors,
    reset,
    customHandleSubmit,
    watch,
    queryParamsValues
  } = methods;

  const watcherCanceledBySupplier = watch('havingItemCanceledBySupplier');
  const bodyshopBranch = watch('bodyshopBranch');
  const state = watch('state');
  const vehicleValue = watch('vehicle');
  const status = watch('status');
  const sortByOldest = watch('sortByOldest');
  const insurer = watch('insurer');
  //#endregion

  //#region Core functions
  function handleClear() {
    onResetSearch();
    reset(INITIAL_FORM_STATE);

    const { firstDateResult, secondDateResult } =
      onLoadDateRangePicker(parameterRangeDays);
    setValue('startDate', firstDateResult);
    setValue('finalDate', secondDateResult);
    setIsIgnoreValidationsDate(false);

    clearErrors();
    setHasClear(true);

    if (optionDefaultCountryDrop !== null) {
      callBodyshopApiDomain();
      callInsurerApiDomain();
    } else {
      dispatch(resetReducerBodyshops());
      dispatch(resetReducerInsurers());
    }
    if (isBodyshopUser && optionDefaultBodyshopDrop) {
      setValue('bodyshopBranch', [optionDefaultBodyshopDrop]);
    }
  }

  function onSubmit(
    formInputs: ISearchClaimForm,
    isQueryParams: boolean = false
  ) {
    setIsInitialLoadScreen(true);

    if (
      isPredefinedDays &&
      (!formInputs.status || formInputs.status.length === 0)
    ) {
      toast.error(getTranslateByKey('information.statusRequired'));
      return;
    }

    const {
      isSortByOldest,
      ignoreValidationsDateSubmit,
      keysIgnoreValidationsDateSubmit,
      rangeParameter
    } = resolveDateValidationRules(formInputs);

    if (isQueryParams && !isIgnoreValidationsDate && !isSortByOldest) {
      if (isNullUndefined(formInputs.startDate)) {
        const valueStartDate = ignoreValidationsDateSubmit
          ? null
          : initalDateForm(parameterRangeDays);

        formInputs.startDate = valueStartDate;
        setValue('startDate', valueStartDate);
      }
      if (isNullUndefined(formInputs.finalDate)) {
        const valueFinalDate = ignoreValidationsDateSubmit
          ? null
          : initalDateForm();

        formInputs.finalDate = valueFinalDate;
        setValue('finalDate', valueFinalDate);
      }
    }

    if (!isSortByOldest)
      validateFormDate(
        formInputs.startDate,
        formInputs.finalDate,
        rangeParameter,
        keysIgnoreValidationsDateSubmit
      );

    const request: ClaimSearchRequest = {
      claimNumber: formInputs.claimNumber,
      delayedClaim: formInputs.delayedClaim,
      onlyDelayedParts: formInputs.delayedParts,
      unreadComments: formInputs.unreadComments,
      guidsBodyShopState: formInputs.state?.map(x => String(x.key)) ?? [],
      idClaimStatus: formInputs.status?.map(x => Number(x.key)) ?? [],
      startDate: isNullUndefined(formInputs.startDate)
        ? ''
        : formatDateToISOString(formInputs.startDate),
      finalDate: isNullUndefined(formInputs.finalDate)
        ? ''
        : formatDateToISOString(formInputs.finalDate),
      initialTotalLoss: formInputs.initialTotalLoss,
      finalTotalLoss: formInputs.finalTotalLoss,
      guidInsurer: formInputs.insurer?.key
        ? String(formInputs.insurer.key)
        : undefined,
      guidsBodyShop: formInputs.bodyshopBranch?.map(x => String(x.key)) ?? [],
      guidMake: formInputs.vehicleManufacturer,
      guidModel: formInputs.vehicleModel,
      guidSubModel: formInputs.subModel,
      havingItemCanceledBySupplier:
        formInputs.havingItemCanceledBySupplier || false,
      sortByOldest:
        formInputs.sortByOldest != null
          ? Number(formInputs.sortByOldest.key)
          : undefined
    };

    if (
      hasInvalidSortByOldestStatus(formInputs.sortByOldest, formInputs.status)
    ) {
      toast.error(getTranslateByKey('information.sortByOldestMultipleStatus'));
      return;
    }

    getDataSearchClaim(removeEmptyValues(request));
    setShowFilters(false);
  }

  function existsInDrop(data: KeyValue[], nameField: any) {
    const fieldValue = getValues(nameField);

    if (Array.isArray(fieldValue)) {
      const filtered = fieldValue.filter(selected =>
        data.some(item => item.key === selected.key)
      );

      setValue(nameField, filtered);
      return;
    }

    const exists = data.find(item => item.key === fieldValue?.key);

    if (!exists) {
      setValue(nameField, null);
    }
  }

  function handleIgnoreValidationsDate(isQueryParams: boolean = false) {
    const valueStartDate =
      isQueryParams && !isNullUndefined(queryParamsValues.startDate)
        ? queryParamsValues.startDate
        : null;
    const valueFinalDate =
      isQueryParams && !isNullUndefined(queryParamsValues.finalDate)
        ? queryParamsValues.finalDate
        : null;

    setValue('startDate', valueStartDate);
    setValue('finalDate', valueFinalDate);
  }

  function handleAcceptDateValidations(isQueryParams: boolean = false) {
    const { firstDateResult, secondDateResult } =
      onLoadDateRangePicker(parameterRangeDays);
    const valueStartDate =
      isQueryParams && !isNullUndefined(queryParamsValues.startDate)
        ? queryParamsValues.startDate
        : firstDateResult;
    const valueFinalDate =
      isQueryParams && !isNullUndefined(queryParamsValues.finalDate)
        ? queryParamsValues.finalDate
        : secondDateResult;

    setValue('startDate', valueStartDate);
    setValue('finalDate', valueFinalDate);
    clearErrors(['startDate', 'finalDate']);
  }

  function checkValidationDates(inputClaimNR: string) {
    if (
      inputClaimNR.length >= PARAMETER_LENTGH_FILTER_CLAIM &&
      !isIgnoreValidationsDate
    ) {
      setIsIgnoreValidationsDate(true);
      return true;
    }
    if (
      inputClaimNR.length < PARAMETER_LENTGH_FILTER_CLAIM &&
      isIgnoreValidationsDate
    ) {
      setIsIgnoreValidationsDate(false);
      return false;
    }
    return null;
  }

  function applyDefaultDates() {
    const { firstDateResult, secondDateResult } =
      onLoadDateRangePicker(parameterRangeDays);

    setValue('startDate', firstDateResult);
    setValue('finalDate', secondDateResult);
  }

  function resolveDateValidationRules(formInputs: ISearchClaimForm) {
    const sortByOldestKey = formInputs.sortByOldest?.key;

    const isFillRange = sortByOldestKey === SortByOldestEnum.fillinarange;
    const isSortByOldest = !isNullUndefined(sortByOldestKey) && !isFillRange;

    const ignoreValidationsDateSubmit =
      formInputs.claimNumber.length >= PARAMETER_LENTGH_FILTER_CLAIM ||
      isSortByOldest;

    const keysIgnoreValidationsDateSubmit = getKeysIgnoreValidationsDate(
      ignoreValidationsDateSubmit,
      formInputs.startDate,
      formInputs.finalDate
    );

    const statusCount = formInputs.status?.length ?? 0;

    const rangeParameter =
      isFillRange || (statusCount === 1 && !isSortByOldest)
        ? maxSearchRangeDaysClaimSearchScreen
        : parameterRangeDays;

    return {
      isFillRange,
      isSortByOldest,
      ignoreValidationsDateSubmit,
      keysIgnoreValidationsDateSubmit,
      rangeParameter
    };
  }

  function hasInvalidSortByOldestStatus(
    sortByOldest: KeyValue | null | undefined,
    status: KeyValue[] | null | undefined
  ) {
    const hasSortByOldest =
      !!sortByOldest?.key ||
      sortByOldest?.key === SortByOldestEnum.fillinarange;

    const hasMultipleStatus = (status?.length ?? 0) > 1;

    return hasSortByOldest && hasMultipleStatus;
  }
  // #endregion

  // #region Async functions
  function callInsurerApiDomain(
    bodyshopSelected?: KeyValue | KeyValue[] | null
  ) {
    // Clean fields & reducers
    dispatch(resetReducerInsurers());

    const request: InsurerFilterRequest = {
      guidCountry: String(optionDefaultCountryDrop?.key),
      type: HeadQuarterBranchFilterEnum.All,
      idStatusRegister: StatusRegisterEnum.Active
    };

    if (bodyshopSelected) {
      const bodyshops = Array.isArray(bodyshopSelected)
        ? bodyshopSelected
        : [bodyshopSelected];

      request.guidsBodyshop = bodyshops.map(x => String(x.key));
    }

    dispatch(getInsurers(request));
  }

  function callBodyshopApiDomain(insurerSelected: KeyValue | null = null) {
    // Clean fields & reducers
    dispatch(resetReducerBodyshops());

    if (optionDefaultCountryDrop !== null) {
      const request: BodyShopFilterRequest = {
        ...(insurerSelected && { guidInsurer: String(insurerSelected.key) }),
        guidCountry: String(optionDefaultCountryDrop?.key),
        type: HeadQuarterBranchFilterEnum.All,
        idStatusRegister: StatusRegisterEnum.Active
      };
      dispatch(getBodyshops(request));
    }
  }

  function callStateBodyshopApiDomain() {
    const requestState: StateFilterRequest = {
      guidCountry: String(optionDefaultCountryDrop?.key)
    };
    dispatch(getStatesUser(requestState));
  }

  function handleOpenModalFavoriteSearch() {
    setOpenModalConfirmationFavoriteSearch(true);
  }

  async function handleConfirmModalFavoriteSearch() {
    setLoadingFavoriteSearch(true);

    const rawValues = getValues();

    const parsed = formSchema.safeParse(rawValues);

    if (!parsed.success) {
      setLoadingFavoriteSearch(false);
      toast.error(getTranslateByKey('information.favoriteSearchSavedError'));
      setOpenModalConfirmationFavoriteSearch(false);
      return;
    }

    const request = parsed.data;
    const { initialTotalLoss, finalTotalLoss } = request;

    if (
      initialTotalLoss !== undefined &&
      finalTotalLoss !== undefined &&
      initialTotalLoss !== '' &&
      finalTotalLoss !== '' &&
      Number(initialTotalLoss) > Number(finalTotalLoss)
    ) {
      toast.error(
        getTranslateByKey('information.initialValueMustBeFinalValue', true)
      );
      setLoadingFavoriteSearch(false);
      return;
    }

    if (
      hasInvalidSortByOldestStatus(rawValues.sortByOldest, rawValues.status)
    ) {
      setLoadingFavoriteSearch(false);
      toast.error(
        getTranslateByKey(
          'information.favoriteSearchMultipleStatusSortByOldest'
        )
      );
      setOpenModalConfirmationFavoriteSearch(false);
      return;
    }

    const result = await saveFavoriteSearch(request);

    if (result) {
      toast.success(
        getTranslateByKey('information.favoriteSearchSavedSuccessfully')
      );
      dispatch(getPredefinedSearch(RoutesConstants.claimSearchClaims));
    } else {
      toast.error(getTranslateByKey('information.favoriteSearchSavedError'));
    }
    setOpenModalConfirmationFavoriteSearch(false);
    setLoadingFavoriteSearch(false);
  }

  function handleOpenModalSavePredefinedSearch() {
    setOpenModalConfirmationSavePredefinedSearch(true);
  }

  function handleOpenModalDeletePredefinedSearch(option: KeyValue) {
    setPredefinedSearchToDelete(option);
    setOpenModalConfirmationDeletePredefinedSearch(true);
  }

  async function handleSavePredefinedSearch(description: string) {
    setLoadingPredefinedSearch(true);

    const rawValues = getValues();

    if (
      hasInvalidSortByOldestStatus(rawValues.sortByOldest, rawValues.status)
    ) {
      setLoadingPredefinedSearch(false);
      toast.error(
        getTranslateByKey(
          'information.predefinedSearchMultipleStatusSortByOldest'
        )
      );
      setOpenModalConfirmationSavePredefinedSearch(false);
      return;
    }

    const parsed = formSchema.safeParse(rawValues);

    if (!parsed.success) {
      setLoadingPredefinedSearch(false);
      toast.error(
        getTranslateByKey('information.userPredefinedSearchSavedError')
      );
      setOpenModalConfirmationSavePredefinedSearch(false);
      return;
    }

    const request = parsed.data;

    const result = await saveUserPredefinedSearch(request, description);

    if (result) {
      toast.success(
        getTranslateByKey('information.userPredefinedSearchSavedSucess')
      );
      dispatch(getPredefinedSearch(RoutesConstants.claimSearchClaims));
    } else {
      toast.error(
        getTranslateByKey('information.userPredefinedSearchSavedError')
      );
    }

    setOpenModalConfirmationSavePredefinedSearch(false);
    setLoadingPredefinedSearch(false);
  }

  async function handleDeletePredefinedSearch() {
    if (!predefinedSearchToDelete) return;
    setLoadingPredefinedSearch(true);

    const result = await deleteUserPredefinedSearch(
      predefinedSearchToDelete.key.toString()
    );

    if (result) {
      toast.success(
        getTranslateByKey('information.userPredefinedSearchDeletedSucess')
      );
      dispatch(getPredefinedSearch(RoutesConstants.claimSearchClaims));
    } else {
      toast.error(
        getTranslateByKey('information.userPredefinedSearchDeletedError')
      );
    }

    setOpenModalConfirmationDeletePredefinedSearch(false);
    setLoadingPredefinedSearch(false);
  }

  async function handleSelectedPredefinedSearch(
    optionSelected: KeyValue | null
  ) {
    if (!optionSelected) return;

    const userPredefinedSearch = await getDetailsUserPredefinedSearch(
      optionSelected.key.toString()
    );
    if (!userPredefinedSearch) return;

    const currentPredefinedValue = optionSelected;

    reset({
      ...INITIAL_FORM_STATE,
      ...userPredefinedSearch,
      predefinedSearch: currentPredefinedValue
    });
    clearErrors(['startDate', 'finalDate']);
    setIsIgnoreValidationsDate(true);

    if (userPredefinedSearch.insurer) {
      callBodyshopApiDomain(userPredefinedSearch.insurer);
    }

    if (
      !userPredefinedSearch.sortByOldest &&
      (!userPredefinedSearch.claimNumber ||
        !checkValidationDates(userPredefinedSearch.claimNumber))
    ) {
      applyDefaultDates();
    }
  }
  //#endregion

  //#region UseEffects
  useEffect(() => {
    if (isNullUndefined(countryReducer.data)) dispatch(getCountriesUser());
    if (isNullUndefined(quoteStatusReducer.data)) dispatch(getQuoteStatus());
    return () => {
      dispatch(resetReducerBodyshops());
      dispatch(resetReducerInsurers());
    };
  }, []);

  useEffect(() => {
    if (!isNullUndefined(optionDefaultCountryDrop)) {
      callBodyshopApiDomain();
      callInsurerApiDomain();
      callStateBodyshopApiDomain();
      dispatch(getPredefinedSearch(RoutesConstants.claimSearchClaims));
    }
  }, [optionDefaultCountryDrop]);

  useEffect(() => {
    if (insurerReducer.data && !insurerReducer.isLoading) {
      const isTypeCompanyUserInsurer = isInsurerUser;
      existsInDrop(insurerReducer.data, 'insurer');
      if (isTypeCompanyUserInsurer && optionDefaultInsurerDrop)
        callBodyshopApiDomain(optionDefaultInsurerDrop);
    }
  }, [insurerReducer.data, insurerReducer.isLoading]);

  useEffect(() => {
    if (bodyshopReducer.data && !bodyshopReducer.isLoading) {
      const isTypeCompanyUserBodyshop = isBodyshopUser;
      existsInDrop(bodyshopReducer.data, 'bodyshopBranch');
      if (isTypeCompanyUserBodyshop && optionDefaultBodyshopDrop)
        callInsurerApiDomain(optionDefaultBodyshopDrop);
    }
  }, [bodyshopReducer.data, bodyshopReducer.isLoading]);

  useEffect(() => {
    if (!isNullUndefined(queryParamsValues.claimNumber)) {
      const isIgnoreValidationDate = checkValidationDates(
        queryParamsValues.claimNumber
      );
      if (!isNullUndefined(isIgnoreValidationDate)) {
        if (isIgnoreValidationDate) {
          handleIgnoreValidationsDate(true);
        } else {
          handleAcceptDateValidations(true);
        }
      }
    }
  }, [queryParamsValues]);

  useEffect(() => {
    const loaded =
      !insurerReducer.isLoading &&
      insurerReducer.data !== null &&
      !bodyshopReducer.isLoading &&
      bodyshopReducer.data !== null &&
      !quoteStatusReducer.isLoading &&
      quoteStatusReducer.data !== null &&
      !stateReducer.isLoading &&
      stateReducer.data !== null;

    if (loaded) setReducersLoaded(true);
  }, [
    insurerReducer.isLoading,
    bodyshopReducer.isLoading,
    quoteStatusReducer.isLoading,
    stateReducer.isLoading
  ]);

  useEffect(() => {
    if (!reducersLoaded) return;
    if (didInitSearch.current) return;

    didInitSearch.current = true;

    const hasQueryParams = Object.keys(queryParamsValues).length > 0;

    if (hasQueryParams) {
      return;
    }

    (async () => {
      if (!showFavouriteSearches) return;

      const favorite = await getFavoriteSearch();
      if (favorite) {
        reset(favorite, { keepDefaultValues: true });
        if (
          !favorite.sortByOldest &&
          (!favorite.claimNumber || !checkValidationDates(favorite.claimNumber))
        ) {
          applyDefaultDates();
        }
      }

      if (isInsurerUser) {
        setValue('insurer', optionDefaultInsurerDrop);
      }
      if (
        isBodyshopUser &&
        favorite?.bodyshopBranch?.length == 0 &&
        !isNullUndefinedEmpty(optionDefaultBodyshopDrop)
      ) {
        setValue('bodyshopBranch', [optionDefaultBodyshopDrop]);
      }

      const data = getValues();
      if (
        favorite &&
        (!favorite.claimNumber || checkValidationDates(data.claimNumber))
      ) {
        return onSubmit(data, true);
      }
    })();
  }, [reducersLoaded]);

  useEffect(() => {
    if (isBodyshopUser && !isNullUndefinedEmpty(optionDefaultBodyshopDrop)) {
      setValue('bodyshopBranch', [optionDefaultBodyshopDrop]);
    }
  }, [optionDefaultBodyshopDrop]);

  useEffect(() => {
    if (watcherCanceledBySupplier) {
      setValue('status', []);
    }
  }, [watcherCanceledBySupplier]);

  useEffect(() => {
    const { firstDateResult, secondDateResult } =
      onLoadDateRangePicker(parameterRangeDays);

    setValue('startDate', firstDateResult);
    setValue('finalDate', secondDateResult);
  }, []);

  const didInitSearch = React.useRef(false);
  //#endregion

  //#region Render constants
  const hasBodyshopDefault =
    isBodyshopUser && bodyshopReducer?.data?.length === 1;
  const isDisabledInsurersDrop = () => isInsurerUser;
  const isDisabledBodyshopDrop = () =>
    bodyshopReducer.data === null || hasBodyshopDefault;
  const ID_SCREEN = 'id-searchClaim';
  const generateIdScreen = (id: string) => `${ID_SCREEN}-${id}`;
  const hasLoadingReducers =
    insurerReducer.isLoading || bodyshopReducer.isLoading;
  const isPredefinedDays =
    sortByOldest?.key !== undefined && !watcherCanceledBySupplier;
  const isPredefinedDaysWithoutFillRange =
    sortByOldest?.key !== undefined &&
    sortByOldest?.key !== SortByOldestEnum.fillinarange;
  const dateRangeParameter =
    status?.length === 1 && !isPredefinedDaysWithoutFillRange
      ? maxSearchRangeDaysClaimSearchScreen
      : parameterRangeDays;
  //#endregion

  return (
    <Box showBox={showFilters} title={getTranslateByKey('information.filters')}>
      <FormProvider {...(methods as any)}>
        <form onSubmit={customHandleSubmit} noValidate>
          <S.Container>
            <S.InputWrapper>
              <KogInputTextControlledNew
                id={generateIdScreen('txt-claimNumber')}
                name="claimNumber"
                label={getTranslateByKey('information.claimNr')}
                control={control}
                autoComplete="off"
                onChangeCustom={value => {
                  const isIgnoreValidationDate = checkValidationDates(value);
                  if (!isNullUndefined(isIgnoreValidationDate)) {
                    if (isIgnoreValidationDate) {
                      handleIgnoreValidationsDate();
                    } else {
                      handleAcceptDateValidations();
                    }
                  }
                }}
              />
            </S.InputWrapper>
            <S.InputWrapper>
              <KogAutoCompleteControlled
                id={generateIdScreen('select-insurer')}
                nameCustom="insurer"
                isDefaultValueUnique={optionDefaultInsurerDrop !== null}
                setValueCustom={setValue}
                label={getTranslateByKey('information.insurer')}
                control={control}
                rulesCustom={{ required: false }}
                errorMessageCustom=""
                hasErrorCustom={false}
                options={insurerReducer.data}
                isLoading={insurerReducer.isLoading}
                disabled={isDisabledInsurersDrop()}
                onChangeCustom={(optionSelected: KeyValue | null) => {
                  if (optionSelected === null) {
                    optionDefaultBodyshopDrop != null
                      ? callInsurerApiDomain(optionDefaultBodyshopDrop)
                      : callInsurerApiDomain();
                  }
                  callBodyshopApiDomain(optionSelected);
                }}
              />
            </S.InputWrapper>

            <S.AutoCompleteWrapper>
              <KOGAutoCompleteCheckbox
                label={getTranslateByKey('information.bodyshopBranch')}
                selectAllLabel={getTranslateByKey('information.selectAll')}
                options={bodyshopReducer.data || []}
                isLoading={bodyshopReducer.isLoading}
                disabled={isDisabledBodyshopDrop()}
                disableSelectAll={!insurer?.key}
                valueCustom={bodyshopBranch ?? []}
                setValueCustom={optionSelected => {
                  setValue('bodyshopBranch', optionSelected);

                  if (optionSelected === null) {
                    optionDefaultInsurerDrop != null
                      ? callBodyshopApiDomain(optionDefaultInsurerDrop)
                      : callBodyshopApiDomain();
                  }
                }}
                onChangeCustom={(value, optionChanged) => {
                  if (optionChanged?.key === 'select-all') {
                    return;
                  }

                  if (!isInsurerUser) {
                    callInsurerApiDomain(value);
                  }
                }}
                customInputProps={{
                  id: 'id-select-bodyshopBranch'
                }}
              />
            </S.AutoCompleteWrapper>
            <VehicleAutoCompleteComponent
              hasClearValue={hasClear}
              setHasClearValue={setHasClear}
              handleChangeVehicle={vehicle => {
                if (vehicle === null) {
                  setValue('vehicleManufacturer', '');
                  setValue('vehicleModel', '');
                  setValue('subModel', '');
                  setValue('vehicle', '');
                } else {
                  setValue(
                    'vehicleManufacturer',
                    vehicle.guidVehicleManufacturer
                  );
                  setValue('vehicleModel', vehicle.guidVehicleModel);
                  setValue('subModel', vehicle.guidSubModel);
                  setValue('vehicle', vehicle.value);
                }
              }}
              vehicleAutoCompleteType={VehicleAutoCompleteTypeEnum.Partial}
              vehicleValueProps={vehicleValue}
            />
            {showPrices && (
              <KOGInputRangeNumberControlled
                idScreen={ID_SCREEN}
                nameInitial="initialTotalLoss"
                nameFinal="finalTotalLoss"
                control={control}
              />
            )}
            <KogKeyboardDatePickerContainer
              idScreen={ID_SCREEN}
              nameStartDate="startDate"
              nameFinalDate="finalDate"
              parameterRangeDays={dateRangeParameter}
              control={control}
              ignoreKeyValidations={getKeysIgnoreValidationsDate(
                isIgnoreValidationsDate,
                watch('startDate'),
                watch('finalDate')
              )}
              disabledFields={
                isPredefinedDaysWithoutFillRange
                  ? ['startDate', 'finalDate']
                  : []
              }
            />
            <S.AutoCompleteWrapper>
              <KOGAutoCompleteCheckbox
                label={getTranslateByKey('information.claimStatus')}
                selectAllLabel={getTranslateByKey('information.selectAll')}
                isLoading={quoteStatusReducer.isLoading}
                options={quoteStatusReducer.data || []}
                disabled={watcherCanceledBySupplier || false}
                valueCustom={status ?? []}
                required={isPredefinedDays}
                setValueCustom={value => {
                  setValue('status', value);
                }}
                customInputProps={{
                  id: 'id-select-status'
                }}
              />
            </S.AutoCompleteWrapper>
            {!isBodyshopUser && (
              <S.AutoCompleteWrapper>
                <KOGAutoCompleteCheckbox
                  label={getTranslateByKey('information.deliveryAddressState')}
                  selectAllLabel={getTranslateByKey('information.selectAll')}
                  isLoading={stateReducer.isLoading}
                  options={stateReducer.data || []}
                  valueCustom={state ?? []}
                  setValueCustom={value => {
                    setValue('state', value);
                  }}
                  customInputProps={{
                    id: 'id-select-state'
                  }}
                />
              </S.AutoCompleteWrapper>
            )}
            {showSortByOldest && (
              <KogAutoCompleteControlled
                id={generateIdScreen('select-sortByOldest')}
                nameCustom="sortByOldest"
                setValueCustom={setValue}
                label={getTranslateByKey('information.sortByOldest')}
                control={control}
                rulesCustom={{ required: false }}
                errorMessageCustom=""
                hasErrorCustom={false}
                options={sortByOldestOptions}
                isLoading={false}
                disabled={false}
                onChangeCustom={(valueSelected: KeyValue | null) => {
                  setValue('sortByOldest', valueSelected);

                  if (valueSelected) {
                    setValue('startDate', null);
                    setValue('finalDate', null);
                    setIsIgnoreValidationsDate(true);
                  } else {
                    const { firstDateResult, secondDateResult } =
                      onLoadDateRangePicker(parameterRangeDays);

                    setValue('startDate', firstDateResult);
                    setValue('finalDate', secondDateResult);
                    setIsIgnoreValidationsDate(false);
                  }
                }}
              />
            )}

            {showPredefinedSearches && (
              <KogAutoCompleteControlledWithDelete
                label={getTranslateByKey('information.predefinedSearches')}
                control={control}
                nameCustom="predefinedSearch"
                rulesCustom={{ required: false }}
                errorMessageCustom=""
                hasErrorCustom={false}
                options={domainPredefinedSearch.data}
                isLoading={domainPredefinedSearch.isLoading}
                onChangeCustom={(optionSelected: KeyValue | null) => {
                  handleSelectedPredefinedSearch(optionSelected);
                }}
                id="id-searchCartsPendingToAnswer-predefinedSearches"
                onDeleteCustom={(option: KeyValue) => {
                  handleOpenModalDeletePredefinedSearch(option);
                }}
              />
            )}

            <S.AreaCheckbox data-compact={!isBodyshopUser ? true : undefined}>
              {showFavouriteSearches && (
                <RenderTooltipMessage
                  tooltipMessage={getTranslateByKey(
                    'information.favoriteSearchTooltipMessage'
                  )}>
                  <S.FavoriteSearchLabel
                    id={generateIdScreen('favorite-searchClaim')}
                    onClick={handleOpenModalFavoriteSearch}
                    control={
                      <FavoriteBorderIcon
                        fontSize="medium"
                        color="primary"
                        style={{ marginRight: 8, marginLeft: 10 }}
                      />
                    }
                    label={getTranslateByKey('information.favoriteSearchClaim')}
                  />
                </RenderTooltipMessage>
              )}
              {showPredefinedSearches && (
                <RenderTooltipMessage
                  tooltipMessage={getTranslateByKey(
                    'information.predefinedSearchTooltipMessage'
                  )}>
                  <S.PredefinedSearchLabel
                    onClick={handleOpenModalSavePredefinedSearch}
                    control={
                      <SearchIcon
                        fontSize="medium"
                        color="primary"
                        style={{ marginRight: 6, marginLeft: 12 }}
                      />
                    }
                    label={getTranslateByKey('information.predefinedSearch')}
                    id="id-searchCartsPendingToAnswer-predefinedSearch"
                  />
                </RenderTooltipMessage>
              )}
            </S.AreaCheckbox>

            <S.AreaCheckbox data-compact={!isBodyshopUser ? true : undefined}>
              {isShowControlByElementId(
                Controls.IdFilterCanceledBySupplier
              ) && (
                <KogCheckBoxControlled
                  nameCustom="havingItemCanceledBySupplier"
                  name="havingItemCanceledBySupplier"
                  control={control}
                  label={getTranslateByKey(
                    'information.filterCanceledBySupplier'
                  )}
                  tooltipMessage={getTranslateByFullKey(
                    't.nah.information.filterCanceledBySupplierDescription'
                  )}
                  id={generateIdScreen('checkBox-canceledBySupplier')}
                />
              )}

              <KogCheckBoxControlled
                id={generateIdScreen('checkbox-unreadComments')}
                label={getTranslateByKey('information.unreadComments')}
                nameCustom="unreadComments"
                control={control}
                tooltipMessage={getTranslateByFullKey(
                  't.nah.information.unreadCommentsDescription'
                )}
              />
            </S.AreaCheckbox>

            <S.AreaCheckbox data-compact={!isBodyshopUser ? true : undefined}>
              <KogCheckBoxControlled
                id={generateIdScreen('checkbox-delayedClaim')}
                label={getTranslateByKey('information.delayedClaim')}
                nameCustom="delayedClaim"
                control={control}
                tooltipMessage={getTranslateByFullKey(
                  't.nah.information.delayedClaimDescription'
                )}
              />

              <KogCheckBoxControlled
                id={generateIdScreen('checkbox-delayedParts')}
                label={getTranslateByKey('information.showDelayedParts')}
                nameCustom="delayedParts"
                control={control}
                tooltipMessage={getTranslateByFullKey(
                  't.nah.information.showDelayedPartsDescription'
                )}
              />
            </S.AreaCheckbox>

            <S.AreaButtons>
              <SecondaryButton
                id={generateIdScreen('btn-submit')}
                disabled={hasLoadingReducers}
                type="submit">
                {getTranslateByKey('information.search')}
              </SecondaryButton>
              <SecondaryButton
                id={generateIdScreen('btn-clear')}
                type="button"
                onClick={handleClear}>
                {getTranslateByKey('information.clear')}
              </SecondaryButton>
            </S.AreaButtons>
          </S.Container>
        </form>
      </FormProvider>

      <BasicModal
        open={openModalConfirmationFavoriteSearch}
        title={getTranslateByKey(
          'information.userPreferenceFavoriteSearchTitle'
        )}
        subtitle={getTranslateByKey(
          'information.userPreferenceFavoriteSearchModalConfirmationMessage'
        )}
        handleClose={() => setOpenModalConfirmationFavoriteSearch(false)}>
        <ButtonsContainer>
          <SecondaryButton
            id={generateIdScreen('btn-cancelSaveFavoriteSearch')}
            variant="outlined"
            onClick={() => setOpenModalConfirmationFavoriteSearch(false)}
            disabled={loadingFavoriteSearch}>
            {getTranslateByKey('information.no')}
          </SecondaryButton>

          <Button
            id={generateIdScreen('btn-saveFavoriteSearch')}
            variant="contained"
            onClick={handleConfirmModalFavoriteSearch}
            isLoading={loadingFavoriteSearch}>
            {getTranslateByKey('information.yes')}
          </Button>
        </ButtonsContainer>
      </BasicModal>

      <ModalSavePredefinedSearch
        open={openModalConfirmationSavePredefinedSearch}
        titleModal={getTranslateByKey('information.savePredefinedSearchTitle')}
        handleModalCancel={() =>
          setOpenModalConfirmationSavePredefinedSearch(false)
        }
        handleModalConfirm={description =>
          handleSavePredefinedSearch(description)
        }
        isLoading={loadingPredefinedSearch}
        idInput={generateIdScreen('input-savePredefinedSearch')}
      />

      <ModalDeletePredefinedSearch
        open={openModalConfirmationDeletePredefinedSearch}
        predefinedSearchName={predefinedSearchToDelete?.value ?? ''}
        handleModalCancel={() =>
          setOpenModalConfirmationDeletePredefinedSearch(false)
        }
        handleModalConfirm={handleDeletePredefinedSearch}
        isLoading={loadingPredefinedSearch}
      />
    </Box>
  );
}

function FiltersSearchClaimWrapper(
  props: Omit<IFiltersSearchClaimProps, 'showFilters' | 'setShowFilters'>
) {
  //#region States
  const [showFilters, setShowFilters] = useState<boolean>(true);
  //#endregion

  //#region HandleFunctions
  function handleFilters() {
    setShowFilters(prev => !prev);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  //#endregion

  const mergedProps: IFiltersSearchClaimProps = {
    ...props,
    showFilters,
    setShowFilters
  };
  return (
    <>
      <AreaButton>
        <Button onClick={handleFilters} id="id-SearchClaim-btn-filters" style={{zIndex: 3}}>
          {getTranslateByKey('information.filters')}
        </Button>
      </AreaButton>
      <FiltersSearchClaim {...mergedProps} />
    </>
  );
}
export default FiltersSearchClaimWrapper;
